import React from "react";
import type { Block, Section } from "../types";
import { InsertBlockButton } from "./menus/insert-block-button";
import EditorBlockRenderer from "./editor-block-renderer";


export function BlockSection({
                               section,
                               fields,
                               platform = "email",
                             }: {
  section: Section;
  fields: Block[];
  platform?: "email" | "web";
}) {
  return (
    <div className="w-full">
      <InsertBlockButton section={section} index={0} outset />
      {fields.map((field, index) => (
        <React.Fragment key={field.id}>
          <EditorBlockRenderer section={section} index={index} blockId={field.id} block={field} platform={platform} />
          {/* Add 16px spacing between blocks to match email renderer */}
          {index < fields.length - 1 && <div className="h-4" />}
          <InsertBlockButton section={section} index={index + 1} isLast={index === fields.length - 1} />
        </React.Fragment>
      ))}
    </div>
  );
}
